export const eSignConsentDescription = 'User Declined E-Sign Consent';
